import Box from '@mui/material/Box';

type PageWrapperProps = {
  children: React.ReactNode;
  fixedWidth?: boolean;
  maxWidth?: number | string;
};

const PageWrapper = ({
  children,
  fixedWidth = false,
  maxWidth,
  ...sxProps
}: PageWrapperProps) => (
  <Box
    sx={{
      blockSize: '100%',
      inlineSize: '100%',
      overflowBlock: 'scroll',
      paddingBlock: 4,
      paddingInline: 5,
      ...sxProps,
    }}
  >
    <Box
      sx={{
        maxWidth: fixedWidth ? (maxWidth ?? 'lg') : '100%',
        margin: '0px auto',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default PageWrapper;
